'use strict';

require('../common/trim');
const isValidEmail = require('./is-valid-email');

module.exports = function (selector, markerClass = 'emailIsValid', formSelector, $submit, invalidAction) {
	const errorContainerSelector = '.errorContainer';
	const errorClass = 'error';
	const $email = window.jQuery(selector);
	if ($email.hasClass(markerClass)) {
		//email validation succeeded, allow form submit...
		return true;
	} else {
		//all other checks have passsed, now let's do that async email validation
		if ($submit) {
			if ($submit.data('original-label') === undefined) {
				$submit.data('original-label', window.jQuery($submit[0]).html());
			}
			$submit.prop('disabled', 'disabled').text('Submitting...');
		}

		const attempt = $email.val();
		//if blank, "valid enough" -- there are other validations for required fields
		if (attempt.length === 0) {
			if ($submit) {
				$submit.prop('disabled', false).html($submit.data('original-label')).removeClass('disabled');
			}
			return true;
		}

		isValidEmail(attempt, (err, result) => {
			if (err) {
				//nothing we can do about a failed validation attempt, and this is client-side, so just allow it to proceed...
				$email.addClass(markerClass);
				//resubmit to proceed
				window.jQuery(formSelector).submit();
			}

			if (result.valid) {
				$email.closest(errorContainerSelector).removeClass(errorClass);
				$email.addClass(markerClass);
				window.jQuery(formSelector).submit();
			} else {
				$email.closest(errorContainerSelector).addClass(errorClass);
				$email
					.closest(errorContainerSelector)
					.find('.errorIcon')
					.html(`<i class="fa fa-fw fa-exclamation-triangle"></i> ${result.error}`);
				if (invalidAction) {
					invalidAction(result);
				}
				if ($submit) {
					$submit.prop('disabled', false).html($submit.data('original-label')).removeClass('disabled');
				}
			}
		});

		//email is being validated async, return false for now. If valid, it will automatically re-submit.
		return false;
	}
};
